module.exports = __webpack_public_path__ + "img/robot_jiagou.4eaff76d.png";